import React from 'react';

import styles from './Spinner.module.css';

const spinner = (props) => (
  <div className={styles.Spinner}>Loading...</div>
);

export default spinner;
